module.exports = __webpack_public_path__ + "static/media/notes.7cbe078f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/notes.png
// module id = 1079
// module chunks = 0